import React from 'react';
import _ from 'lodash';

import DropdownSelector, {
  renderTooltipContent,
  setTippyHide,
} from '../DropdownSelector';
import InfinityScrollLoad from '../../InfinityScrollLoad';
import Tippy from '../../ReactTippy';
import { ArrowDownIcon } from '../../icons/ArrowDownIcon';
import { RadioButtonIcon } from '../../icons/RadioButtonIcon';

import ProgressService from '../../../services/Progress';
import SessionStorageService from '../../../services/utilities/SessionStorageService';

import { checkSelectedAll } from '../../../utilities/commonUtil';
import { messageUtility } from '../../../utilities/messageUtility';

// single or multi-select dropdown selector
export default class ProgressTemplateSelector extends DropdownSelector {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      disabledName: 'work_registered_flag',
      isUsed: 'using_flag',
      listWorkTypeTemplates: [],
      listHistoryWorkTypeTemplates: [],
      historySelectAll: false,
      isMounted: false,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    if (_.isUndefined(this.props.loaded) && this.state.api) {
      this.loadData();
    }
    this.getProgressListWorkTypeTemplates();
  }

  getProgressListWorkTypeTemplates = async () => {
    const response = await ProgressService.getProgressListWorkTypeTemplates(
      SessionStorageService.getFieldId(),
      {
        using_flag: 1,
      }
    );

    if (response.result) {
      const work_type_templates = _.get(
        response,
        'data.entities.work_type_templates'
      );
      const templates = _.isEmpty(work_type_templates)
        ? []
        : _.map(work_type_templates, template => {
            const {
              name,
              id,
              work_registered_flag,
              using_flag,
              order_number,
            } = template;
            return {
              name,
              id: `${id}`,
              work_registered_flag,
              using_flag,
              order_number,
            };
          });
      this.setState(
        {
          listWorkTypeTemplates: templates,
          listHistoryWorkTypeTemplates: templates,
          isMounted: true,
        },
        () => this.props.getDefaultTemplateIds(this.state.listWorkTypeTemplates)
      );
    }
  };

  resetSelected = () => {
    if (this.state.opened) {
      // Trigger event handler for closing dropdown
      this.props.onClose && this.props.onClose();
    }

    const historyOptions = _.map(
      this.state.listHistoryWorkTypeTemplates,
      op => {
        return parseInt(op.id);
      }
    );

    this.setState({
      opened: false,
      selectAll: this.state.historySelectAll,
      options: _.map(this.state.options, op => {
        return _.includes(historyOptions, parseInt(op.id))
          ? { ...op, using_flag: true }
          : { ...op, using_flag: false };
      }),
      listWorkTypeTemplates: this.state.listHistoryWorkTypeTemplates,
      temporarySelected: _.map(this.state.listHistoryWorkTypeTemplates, this.state.valueName),
    });
  };

  handleSelectAll = () => {
    const { options, selectAll } = this.state;
    if (!selectAll) {
      this.setState(
        {
          options: _.map(options, op => {
            return { ...op, using_flag: true };
          }),
          selectAll: !selectAll,
        },
        () => {
          this.setWorkTypeTemplates();
        }
      );
    } else {
      this.setState(
        {
          options: _.map(options, op => {
            return op.work_registered_flag ? op : { ...op, using_flag: false };
          }),
          selectAll: !selectAll,
        },
        () => {
          this.setWorkTypeTemplates();
        }
      );
    }
  };

  /**
   * 選択時のイベント
   * @param {string} value // id
   * @param {boolen} checked
   * @param {string} name
   */
  handleSelectedRow = (id, checked) => {
    const selectedRow = _.find(this.state.options, option => {
      return option.id === id;
    });
    const newListTemplates = [...this.state.listWorkTypeTemplates, selectedRow];
    let temporarySelected = _.compact(this.state.temporarySelected);
    if (id) {
      if (checked) {
        temporarySelected = this.state.multiple
          ? _.union(temporarySelected, [id])
          : [id];
      } else {
        temporarySelected = this.state.multiple
          ? _.pull(temporarySelected, id)
          : [];
      }
    }
    if (checked) {
      this.setState({
        listWorkTypeTemplates: newListTemplates,
        options: _.map(this.state.options, op => {
          return op.id !== id ? op : { ...op, using_flag: !op.using_flag };
        }),
        selectAll: checkSelectedAll(_.map(newListTemplates, this.state.valueName), _.map(this.state.options, this.state.valueName)),
        temporarySelected,
      }, () => {
        this.setValue();
      });
    } else {
      this.setState(prevState => ({
        listWorkTypeTemplates: _.filter(
          prevState.listWorkTypeTemplates,
          template => {
            return parseInt(template.id) !== parseInt(id);
          }
        ),
        options: _.map(prevState.options, op => {
          return op.id !== id ? op : { ...op, using_flag: !op.using_flag };
        }),
        selectAll: false,
        temporarySelected,
      }), () => {
        this.setValue();
      });
    }
  };

  /**
   * apiからのデータを加工
   * @param {object} responseData
   */
  bindResponseDataToObject = responseData => {
    let newResponseData = _.cloneDeep(responseData);
    if (_.isFunction(this.props.sorted)) {
      // 任意の順に並び替え
      newResponseData = this.props.sorted(newResponseData);
    }

    const { keyName, valueName, disabledName, isUsed, listWorkTypeTemplates, isMounted } = this.state;

    const tmp = _.map(newResponseData, data => {
      const permittedKeys = [
        { keyName: 'order_number', defaultValue: 0 },
        ...(this.props.responseParseKeys || []),
      ];

      const result = {
        [keyName]: String(data[keyName]),
        [valueName]: String(data[valueName]),
        [disabledName]: data[disabledName],
        [isUsed]: isMounted
          ? _.some(listWorkTypeTemplates, template => String(template[valueName]) === String(data[valueName]))
          : data[isUsed],
      };

      _.each(permittedKeys, ({ keyName, defaultValue }) => {
        result[keyName] = data[keyName] || defaultValue;
      });

      return result;
    });

    // order_number順に並び替え
    return this.props.sorted ? tmp : _.orderBy(tmp, item => item.order_number);
  };

  setWorkTypeTemplates = () => {
    const { options, listWorkTypeTemplates } = this.state;
    const optionValues = _.map(options, op => {
      return parseInt(op.id);
    });
    const diffOptions = _.filter(listWorkTypeTemplates, template => {
      return !_.includes(optionValues, parseInt(template.id));
    });
    const newOptions = _.filter(options, op => {
      return op.using_flag === true;
    });
    const allValues = [...newOptions, ...diffOptions];
    this.setState({
      listWorkTypeTemplates: allValues,
      temporarySelected: _.map(allValues, this.state.valueName),
    }, () => {
      this.setValue();
    });
  };

  setValue = () => {
    const { listWorkTypeTemplates, selectAll } = this.state;
    const values = _.map(listWorkTypeTemplates, template => {
      return `${template.id}`;
    });
    this.setState({
      listHistoryWorkTypeTemplates: listWorkTypeTemplates,
      historySelectAll: selectAll,
      opened: this.state.multiple,
      selected: listWorkTypeTemplates,
    }, () => {
      this.props.onSelect(values);
    });
  };

  render() {
    const getName = () => {
      const { label, listWorkTypeTemplates } = this.state;
      const listSortTemplates = _.isEmpty(listWorkTypeTemplates)
        ? []
        : _.sortBy(listWorkTypeTemplates, ['order_number']);
      let name = label;
      if (listWorkTypeTemplates && listWorkTypeTemplates.length > 0) {
        name = _.join(_.map(listSortTemplates, this.state.keyName), ',');
      }
      return name;
    };

    const gotName = getName();
    return (
      <div
        className={`dropdown-multi-select${
          this.state.className !== '' ? ` ${this.state.className}` : ''
        }`}
        ref={this.parent}
      >
        <div
          className={`dropdown-multi-select__header ${
            this.state.opened ? ' show' : ''
          }`}
        >
          <a
            href=''
            className={`dropdown-select${this.state.opened ? ' show' : ''}`}
            onClick={this.handleOpen}
            style={this.state.dropdownSelectStyle}
          >
            <span
              className={`dropdown-select__txt${
                this.state.expandable ? ' expandable' : ''
              }`}
            >
              {gotName}
            </span>
          </a>
          <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
        </div>
        {this.state.opened && (
          <div className='dropdown dropdown--dropdown-list show'>
            <div
              className={`dropdown__item ${
                !_.isUndefined(this.props.widthClass)
                  ? this.props.widthClass
                  : ''
              } ${this.props.isHideHiddenItem ? '' : 'dropdown__item--hidden'}`}
            >
              {this.state.apiSearchKey !== '' && (
                <div className='dropdown-multi-select__item'>
                  <i className='i-search i-2x' />
                  <input
                    type='text'
                    id={`searchKey${this.uid}`}
                    className='SearchDropdown'
                    defaultValue={this.state.condition.name}
                    name='search'
                    placeholder={messageUtility.getMessage('I-000-090')}
                    onChange={this.setCondition}
                  />
                </div>
              )}
              {this.state.multiple && (
                <div className='dropdown-multi-select__item'>
                  <div className='dropdown-multi-select__checkall'>
                    <div className='btn-checkbox'>
                      <label htmlFor={`checkall-group-${this.uid}`}>
                        <input
                          id={`checkall-group-${this.uid}`}
                          type='checkbox'
                          checked={this.state.selectAll}
                          onClick={this.handleSelectAll}
                        />
                        <i className='i-square-checkbox i-2_5x' />
                      </label>
                    </div>
                    {/* ラベルクリックでラジオボタン選択のため(全選択) */}

                    {/* ツールチップ */}
                    {this.props.hasTooltipAllSelect ? (
                      <Tippy
                        duration={10}
                        multiple={false}
                        arrow={true}
                        arrowType='sharp'
                        placement='bottom'
                        // maxWidth='160px'
                        html={
                          <div
                            style={{
                              fontSize: '10px',
                              lineHeight: '16px',
                              textAlign: 'left',
                              color: 'white',
                            }}
                          >
                            全選択する場合は最下部までスクロールしてください
                          </div>
                        }
                      >
                        <label htmlFor={`checkall-group-${this.uid}`}>
                          {messageUtility.getMessage('I-000-092')}
                        </label>
                      </Tippy>
                    ) : (
                      <label htmlFor={`checkall-group-${this.uid}`}>
                        {messageUtility.getMessage('I-000-092')}
                      </label>
                    )}
                  </div>
                </div>
              )}
              <div className='dropdown-multi-select__item'>
                <div
                  className='dropdown-multi-select__scroll'
                  id={this.targetId}
                >
                  <ul
                    className={
                      this.state.multiple ? 'multi-select' : 'single-select'
                    }
                  >
                    {_.map(this.state.options, option => (
                      <SelectableOption
                        disabled={option[this.state.disabledName]}
                        key={option[this.state.valueName]}
                        option={option}
                        checked={option[this.state.isUsed]}
                        targetId={this.id}
                        handleSelectedRow={this.handleSelectedRow}
                        state={this.state}
                        multiple={this.state.multiple}
                        itemWidthClass={
                          !_.isUndefined(this.props.itemWidthClass) &&
                          this.state.opened === true
                            ? this.props.itemWidthClass
                            : ''
                        }
                      />
                    ))}
                    <InfinityScrollLoad
                      targetId={this.targetId}
                      total={_.size(this.state.options)}
                      isLoading={this.state.isLoading}
                      callback={this.handleInview}
                      ignoreIndicator={true}
                    />
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const SelectableOption = ({
  disabled,
  option,
  checked,
  targetId,
  handleSelectedRow,
  state,
  multiple,
  itemWidthClass,
}) => {
  return multiple ? (
    <li className={`multi-select__item ${itemWidthClass}`}>
      <div className='btn-checkbox'>
        {disabled ? (
          <Tippy
            duration={10}
            distance={24}
            arrowType='sharp'
            delay={[500, 0]}
            placement='bottom'
            followCursor={true}
            role={`tippy_target_${_.uniqueId()}`}
            html={renderTooltipContent(
              'すでに現場で作業予定・実績が登録されている工種を含むため、選択を解除できません。'
            )}
          >
            <label
              htmlFor={`single-field-a-item-id-${
                option[state.valueName]
              }-${targetId}`}
            >
              <input
                id={`single-field-a-item-id-${
                  option[state.valueName]
                }-${targetId}`}
                type='checkbox'
                disabled={disabled}
                checked={disabled ? true : checked}
                onClick={() =>
                  handleSelectedRow(option[state.valueName], !checked)
                }
              />
              <i
                className={`i-square-checkbox i-2_5x ${disabled &&
                  'i-square-disabled'}`}
              />
            </label>
          </Tippy>
        ) : (
          <label
            htmlFor={`single-field-a-item-id-${
              option[state.valueName]
            }-${targetId}`}
          >
            <input
              id={`single-field-a-item-id-${
                option[state.valueName]
              }-${targetId}`}
              type='checkbox'
              disabled={disabled}
              checked={checked}
              onClick={() =>
                handleSelectedRow(option[state.valueName], !checked)
              }
            />
            <i
              className={`i-square-checkbox i-2_5x ${disabled &&
                'i-square-disabled'}`}
            />
          </label>
        )}
      </div>

      {/* tooltip */}
      <Tippy
        duration={10}
        arrow={true}
        arrowType='sharp'
        placement='bottom'
        role={`tippy_target_${targetId}_${option[state.keyName]}_${
          option[state.valueName]
        }`}
        html={renderTooltipContent(option[state.keyName])}
        onShow={setTippyHide}
      >
        <div
          className={`multi-select__label tippy_target_${targetId}_${
            option[state.keyName]
          }_${option[state.valueName]}`}
          onClick={() =>
            !disabled && handleSelectedRow(option[state.valueName], !checked)
          }
        >
          {option[state.keyName]}
        </div>
      </Tippy>
    </li>
  ) : (
    <li className={`single-select__item ${itemWidthClass}`}>
      <label
        className='radio'
        htmlFor={`single-field-a-item-id-${
          option[state.valueName]
        }-${targetId}`}
      >
        <input
          id={`single-field-a-item-id-${option[state.valueName]}-${targetId}`}
          type='radio'
          disabled={disabled}
          checked={checked}
          onChange={() => handleSelectedRow(option[state.valueName], !checked)}
        />
        <RadioButtonIcon className='icon--1_6x' />
        {/* tooltip */}
        <Tippy
          delay={[500, 0]}
          duration={10}
          distance={24}
          placement='bottom'
          followCursor={true}
          role={`tippy_target_${targetId}_${option[state.keyName]}_${
            option[state.valueName]
          }`}
          html={renderTooltipContent(option[state.keyName])}
          onShow={setTippyHide}
        >
          <span
            className={`single-select__label tippy_target_${targetId}_${
              option[state.keyName]
            }_${option[state.valueName]}`}
          >
            {option[state.keyName]}
          </span>
        </Tippy>
      </label>
    </li>
  );
};



// WEBPACK FOOTER //
// ./src/components/dropdowns/multi/ProgressTemplateSelector.jsx